import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { MeResponse } from '@platform/shared';
import { api, ApiError } from '../api/client';

export const ME_KEY = ['me'] as const;

/** The signed-in person, or null when there is no live session. Errors other than 401 surface. */
export async function fetchMe(): Promise<MeResponse | null> {
  try {
    return await api.me();
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null;
    throw err;
  }
}

export function useMe() {
  return useQuery<MeResponse | null, ApiError>({ queryKey: ME_KEY, queryFn: fetchMe, staleTime: 60_000 });
}

export function useInvalidateMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ME_KEY });
}
